export default {
  name: 'BFA',
  domain: 'bionutrient',
  id: '608d7e971c6a18000147f33a',
  slug: 'bionutrient',
  path: '/bionutrient/',
  logo: '/partners/bionutrient/img/logo.png',
  hero: '/partners/bionutrient/img/hero.png',
  themes: {
    light: {
      primary: '#EB6E23',
      secondary: '#899856',
      accent: '#FF5722',
      error: '#f44336',
      warning: '#ffc107',
      info: '#26AAE2',
      success: '#8bc34a',
      appbar: '#ffffff',
      background: '#649747',
      focus: '#524C40',
      heading: '#899856',
    },
  },
};
